import { Injectable } from '@angular/core';
import { LoggingService } from 'src/app/_services/logging/logic/logging.service';
import { GenericRemoteActionBuilderServiceStep } from '../remote-action-builder-steps';
import { ClientStateService } from 'src/app/_services/client-state/logic/client-state.service';
import { Place } from 'src/app/_model/place';

@Injectable()
export class TourIdRemoteActionBuilderServiceStep
  implements GenericRemoteActionBuilderServiceStep {
  constructor(
    private clientStateService: ClientStateService,
    private logger?: LoggingService
  ) {}

  public async getDataValues(): Promise<{ key: string; value: any }[]> {
    let tourId = this.clientStateService.theState.getValue().tourId;

    this.logger.log(
      this.constructor.name,
      "Found tour for remote action data",
      tourId
    )

    if (tourId) {
      return [
        { key: 'tourimsid', value: tourId.imsId },
      ]
    } else {
      return []
    }

     
  }
}
